//<img src="../assets/flatiron.png" style="width:50%"></img>

   // <p>
     // In 2018, I interned at <a href="https://flatiron.com">flatiron health</a>. I used Elasticsearch and React to build a better disease search for doctors.
  //  </p>

<template>

  <div>
    <ul>
      <li><a href="//johannmiller.com/resume.pdf">resume</a></li>
      <li><a href="//github.com/johannkm">github</a></li>
      <li><a href="//www.linkedin.com/in/johannkm/">linkedin</a></li>
    </ul>

    <hr style="margin-top: 3em"/>

    <p>
      In 2019, I interned at <a href="https://databricks.com">databricks</a>. I built a monitoring pipeline with Kafka, and wrote about it in this
       <a href="https://databricks.com/blog/2019/05/06/real-time-distributed-monitoring-and-logging-in-the-azure-cloud.html">blog post</a>.
    </p>
    <br/>
    <a href="https://databricks.com/blog/2019/05/06/real-time-distributed-monitoring-and-logging-in-the-azure-cloud.html"><img src="../assets/pipeline.png"></img></a>

    <hr/>

    <p>
      In 2017 I worked on <a href="https://sidewalk-sea.cs.washington.edu">project sidewalk</a>. I investigated methods for predicting the quality of crowd-sourced data, and wrote this <a href="https://johannkm.github.io/cmsc499A/">report</a>.
    </p>
    <br/>
    <a href="https://johannkm.github.io/cmsc499A/"><img style="max-width:100%" src="../assets/sidewalk.jpg"></img></a>

    <hr/>

    <p>
      At HopHacks (the Johns Hopkins hackathon), I worked with friends to build a VR app that helps with public speaking. We won 1st place overall.
      You can read about our project on <a href="//devpost.com/software/speechportal">devpost</a>. The event was also covered by the <a href="//www.baltimoresun.com/news/maryland/education/higher-ed/bs-md-johns-hopkins-hophacks-20170219-story.html">baltimore sun</a> and <a href="//hub.jhu.edu/2017/02/20/hophacks-spring-2017-memory-app/">jhu hub</a>.
    </p>

    <blockquote class="twitter-tweet tw-align-center" data-lang="en"><p lang="en" dir="ltr">Congrats to Kevin Chen, Johann Miller, Ricky Han, and Jason Zou for winning the Hopkins Hackathon with their hack Speechportal! <a href="https://t.co/vu9LzCM7Si">https://t.co/vu9LzCM7Si</a></p>&mdash; UMD CS Department (@umdcs) <a href="https://twitter.com/umdcs/status/833748457210929153">February 20, 2017</a></blockquote>

    <hr/>

    <p id="part-2">
      In 2016 I interned at the National Cancer Institute in Bruce Shapiro's RNA structure and design lab. I wrote software to predict 3D RNA structure like this:
    </p>

    <img src="../assets/triangleChimera.jpg"></img>

    <p>
      This model was used in a research paper in <a href="//www.ncbi.nlm.nih.gov/pubmed/28108656">nucleic acids research</a>.
    </p>

    <hr style="margin-bottom: 2em;"/>

    <ul>
      <li><a href="//johannmiller.com/resume.pdf">resume</a></li>
      <li><a href="//github.com/johannkm">github</a></li>
      <li><a href="//www.linkedin.com/in/johannkm/">linkedin</a></li>
    </ul>

  </div>
</template>

<script>
require('../assets/twitter.js')

export default{
  name: 'code-page',
  mounted: function(){
    twttr.widgets.load()
  }
}

</script>

<style >

  .twitter-tweet {
    padding-top: 18px!important;
    padding-bottom: 18px!important;
    border: none;
  }

</style>

<style scoped>

hr {
  display: block; height: 3px;
    border: 0; border-top: 3px solid #ddd;
    margin: 1em 0; padding: 0; 
  margin-top: 4em;
  margin-bottom: 4em;
}

img {
  width: 100%;
  max-width: 400px;
  border-radius: 0.2%;
}

ul {
  list-style: none;
  padding: 0;
  padding-top: 1em;
}

#part-2 {
  padding-top: 1em;
  padding-bottom: 1em;
}

blockquote.twitter-tweet {
  display: inline-block;
  padding: 16px;
  margin: 10px 0;
  max-width: 468px;
  border: #ddd 1px solid;
  border-top-color: #eee;
  border-bottom-color: #bbb;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.15);
  font: bold 14px/18px Helvetica, Arial, sans-serif;
  color: #000;
}

blockquote.twitter-tweet p {
  font: normal 18px/24px Georgia, "Times New Roman", Palatino, serif;
  margin: 0 5px 10px 0;
}

blockquote.twitter-tweet a[href^="https://twitter.com"] {
  font-weight: normal;
  color: #666;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// CodePage.vue?5a463bba